import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
import { deepMix } from '@antv/util';
function range(direction, iterationCount, keyframeCount) {
  var start = 0;
  var end = keyframeCount;
  var normal = [start, end];
  var reverse = [-end + 1, -start + 1];
  if (direction === 'normal') return normal;
  if (direction === 'reverse') return reverse;
  if (direction === 'alternate') {
    return iterationCount % 2 === 0 ? normal : reverse;
  }
  if (direction === 'reverse-alternate') {
    return iterationCount % 2 === 0 ? reverse : normal;
  }
}
/**
 * Set animation options for all descendants.
 */
function setAnimation(node, duration, easing) {
  var discovered = [node];
  while (discovered.length) {
    var n = discovered.pop();
    n.animate = deepMix({
      enter: {
        duration: duration
      },
      update: {
        duration: duration,
        easing: easing,
        type: 'morphing',
        fill: 'both'
      },
      exit: {
        type: 'fadeOut',
        duration: duration
      }
    }, n.animate || {});
    var children = n.children;
    if (Array.isArray(children)) discovered.push.apply(discovered, _toConsumableArray(children));
  }
  return node;
}
/**
 * @todo More options, such as fill, totalDuration...
 */
export var TimingKeyframe = function TimingKeyframe() {
  return function (options) {
    var _options$children = options.children,
      children = _options$children === void 0 ? [] : _options$children,
      _options$duration = options.duration,
      duration = _options$duration === void 0 ? 1000 : _options$duration,
      _options$iterationCou = options.iterationCount,
      iterationCount = _options$iterationCou === void 0 ? 1 : _options$iterationCou,
      _options$direction = options.direction,
      direction = _options$direction === void 0 ? 'normal' : _options$direction,
      _options$easing = options.easing,
      easing = _options$easing === void 0 ? 'ease-in-out-sine' : _options$easing;
    var n = children.length;
    if (!Array.isArray(children) || n === 0) return [];
    var key = children[0].key;
    var newChildren = children.map(function (d) {
      return Object.assign(Object.assign({}, d), {
        key: key
      });
    }).map(function (d) {
      return setAnimation(d, duration, easing);
    });
    return /*#__PURE__*/_regenerator().m(function _callee() {
      var count, prevIndex, _range, _range2, start, end, i, index;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            count = 0;
          case 1:
            if (!(iterationCount === 'infinite' || count < iterationCount)) {
              _context.n = 6;
              break;
            }
            _range = range(direction, count, n), _range2 = _slicedToArray(_range, 2), start = _range2[0], end = _range2[1];
            i = start;
          case 2:
            if (!(i < end)) {
              _context.n = 5;
              break;
            }
            // For reverse direction, the range is from negative to negative
            // so the absolute value of i is the real index for newChildren.
            index = Math.abs(i); // This is for preventing alternate or reverse-alternate keyframe
            // to yield two same node one by one when the direction change.
            if (!(prevIndex !== index)) {
              _context.n = 3;
              break;
            }
            _context.n = 3;
            return newChildren[index];
          case 3:
            prevIndex = index;
          case 4:
            i += 1;
            _context.n = 2;
            break;
          case 5:
            count++;
            _context.n = 1;
            break;
          case 6:
            return _context.a(2);
        }
      }, _callee);
    });
  };
};
TimingKeyframe.props = {};